import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const SurveySelectionReducer = createSlice({
    name: "surveyComputedData",
    initialState,
    reducers: {
        selectedSurvey: (state, action) => {
            return action.payload;
        }
    }
});
export const {selectedSurvey} = SurveySelectionReducer.actions;

export default SurveySelectionReducer.reducer;